import React, { Component } from 'react';
import { muiWithStyles, MuiGrid, MuiButton, MuiAddCircle, MuiTypography } from '../../../ui/MaterialUIComponents';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import theme from '../../../../assests/theme'
import { AssigningSubjectComponent } from './AssigningSubjectComponent';
export class AssignTeacherForSubjectComponent extends Component {

  constructor(props) {
    super(props)
    this.state = {

    }
  }



  render() {
    const { classes, i18n } = this.props
    return (
      <div>

        < MuiGrid container xs={12}  >
          < MuiGrid container xs={12} style={theme.tableHeaderStyle}>
            {/* < MuiGrid container xs={12} direction='row' style={theme.gridHeaderStyle}> */}
            < MuiGrid item xs={2}>   <MuiTypography style={theme.tableHeaderTextStyle}>
              {i18n.teachers.subjectName}
            </MuiTypography></ MuiGrid>
            < MuiGrid item xs={2}>   <MuiTypography style={theme.tableHeaderTextStyle}>
              {i18n.teachers.subjectCode}
            </MuiTypography></ MuiGrid>
            < MuiGrid item xs={2}>   <MuiTypography style={theme.tableHeaderTextStyle}>
              {i18n.teachers.mainTeacher}
            </MuiTypography></ MuiGrid>
            < MuiGrid item xs={2}>   <MuiTypography style={theme.tableHeaderTextStyle}>
              {i18n.teachers.assignmentPreference}
            </MuiTypography></ MuiGrid>
            < MuiGrid item xs={4}>   <MuiTypography style={theme.tableHeaderTextStyle}>
              {i18n.teachers.subjectGradeDetail}
            </MuiTypography></ MuiGrid>
          </ MuiGrid>

          {this.props.assignedSubjects.map((assignedSubject, index) =>
            < MuiGrid item xs={12} id='grid'>
              <AssigningSubjectComponent {...this.props} assignedSubject={assignedSubject} index={index} />
            </ MuiGrid>
          )}

          <MuiGrid container xs={12} style={theme.gridActionContainerStyle} justify="center" alignItems="center" onClick={() => this.props.renderAddSubjectRow()}>
            <MuiGrid item >

              <MuiAddCircle style={{ color: theme.palette.orange }} fontSize='large' />

            </MuiGrid>
            <MuiGrid item  >
              <MuiTypography style={theme.addMoreStyle}>
                {i18n.teachers.addMoreSubjects}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>

          {/* </ MuiGrid> */}
        </ MuiGrid>
      </div>
    )
  }
}
export default AssignTeacherForSubjectComponent

